export default {
    articles (state) {
      return state.articles
    },

    selectedArticle (state) {
        return state.selectedArticle
    },

    getArticle: state => (articleId) => {
      return state.articles().find(article => article.articleId === articleId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/articles/getters.js